import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export const refreshTripsCache = () => {
  cache = null;
};

export function useTrips() {
  const [trips, setTrips] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    let alive = true;
    if (!cache) {
      api
        .get("/trips")
        .then((res) => {
          cache = Array.isArray(res.data) ? res.data : [];
          if (alive) setTrips(cache);
        })
        .catch(() => alive && setTrips([]))
        .finally(() => alive && setLoading(false));
    }
    return () => {
      alive = false;
    };
  }, []);

  return { trips, loading };
}

export function groupDestinations(trips, region) {
  const map = {};
  trips
    .filter((t) => !region || t.region === region)
    .forEach((t) => {
      const d = map[t.destination];
      if (!d) map[t.destination] = { name: t.destination, image: t.image, from: t.price, count: 1, region: t.region };
      else {
        d.count += 1;
        d.from = Math.min(d.from, t.price);
      }
    });
  return Object.values(map);
}
